module.exports = __webpack_public_path__ + "media/images/logo2-1f1386c7.png";